module.exports = __webpack_public_path__ + "img/trade-04.ae6153ea.png";